<template>
  <v-container class="pa-0 ma-0">
    <v-card width="100%" class="mx-auto" @click="open">
      <v-list-item>
        <v-list-item-content class="pa-0">
          <v-list-item-title class="subtitle-2 pa-0">
            {{ professional.professionalName }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-card-text class="pa-0">
        <v-container class="ma-0 pa-0 px-2">
          <v-row no-gutters align="center" justify="space-around">
            <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9">
              <div style="min-height: 116px;">

                <div class="subtitle-1">{{ professional.specialities }}</div>

                <div>{{ `${(professional.attendCovenant) ? 'Atende meu convênio' : ''}` }}</div>

                <div>
                  <div v-if="professional.nextProfessionalDate">
                    <!-- {{ professional.professionalTimesQtd }}
                    horário{{ `${professional.professionalTimesQtd > 0 ? 's' : ''}` }} -->
                    Horário disponível em {{ professional.nextProfessionalDate | date }}
                  </div>
                  <div v-else>
                    Nenhum horário disponível no momento
                  </div>
                </div>

                <div>
                  <div v-if="professional.nextSchedule">
                    Consulta agendada em {{ professional.nextSchedule | date  }}
                  </div>
                  <div v-else>Você não tem consulta agendada</div>
                </div>
              </div>
            </v-col>
            <v-col no-gutters xl="2" lg="2" md="2" sm="2" cols="3">
              <v-list-item-avatar :size="($vuetify.breakpoint.xsOnly) ? 48 : 60" color="secondary">
                <v-img :src="professional.avatar"></v-img>
              </v-list-item-avatar>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-btn text icon @click.stop="confirmRemove = true">
          <v-icon :loading="removeLoading">mdi-close</v-icon>
        </v-btn>

        <v-spacer></v-spacer>

        <share-professional :professionalId="professional.id" />

        <v-spacer></v-spacer>

        <v-btn text icon @click.stop="open">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>

    <confirmation-dialog v-model="confirmRemove" @confirm="remove">
      <div>Deseja remover <b>{{ professional.professionalName }}</b> dos Meus Médicos?</div>
    </confirmation-dialog>
  </v-container>
</template>

<script>
import bus from '@/plugins/eventBus';
import ConfirmationDialog from '@/components/general/ConfirmationDialog';
import ShareProfessional from '@/components/general/ShareProfessional';

export default {
  props: {
    value: {
      type: Object,
    },
  },
  data: () => ({
    professional: null,
    removeLoading: false,
    confirmRemove: false,
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
  },
  created() {
    this.professional = this.value;
  },
  destroyed() {
    this.confirmRemove = false;
  },
  methods: {
    open() {
      this.$emit('open', this.professional);
    },
    remove() {
      this.removeLoading = true;
      this.$store
        .dispatch('patientProfessionals/remove', {
          patientId: this.professional.patientId,
          professionalId: this.professional.id,
        })
        .then(() => {
          bus.$emit('message', {
            message: 'Profissional removido com sucesso!',
            type: 'success',
          });
          this.$emit('removed', this.professional.id);
        })
        .catch((err) => {
          bus.$emit('message', {
            message: err.response.data.message,
            type: 'error',
          });
        })
        .finally(() => {
          this.removeLoading = true;
        });
    },
  },
  components: {
    ConfirmationDialog,
    ShareProfessional,
  },
};
</script>
